<template>
  <nav>
    <v-toolbar app id="core-toolbar" prominent color="amber">
      <div class="v-toolbar-title">
        <v-toolbar-title class="tertiary--text font-weight-light">
          <v-btn icon @click="drawer = !drawer" color="#2c394d">
            <v-icon color="amber">view_list</v-icon>
          </v-btn >
          <span class="pt-1" style="color: #2c394d; vertical-align: middle;">
          {{ $route.name }}
          </span>
        </v-toolbar-title>
      </div>
      <v-spacer/>
      <v-btn icon>
        <v-icon color="#2c394d">dashboard</v-icon>
      </v-btn>
      <v-btn icon @click="signout">
        <v-icon color="#2c394d">fas fa-sign-out-alt</v-icon>
      </v-btn>
    </v-toolbar>

    <v-navigation-drawer
      id="app-drawer"
      v-model="drawer"
      app
      floating
      persistent
      mobile-break-point="991"
      width="260"
      dark
    >
      <v-img
        src="/sidebar-1.jpg"
        height="100%"
        gradient="to right, #35455c 92%, #2c394d 100%" 
      >
      <v-card max-width="259" color="rgba(0,0,0,0)" flat>
        <v-flex>
            <v-layout class="fill-height ml-2 mr-2 " column dark>
              <v-layout pa-3>
                
                  <v-img
                    src="/CB-logo.png"
                    height="70"
                    contain
                  />
                
              </v-layout>
              <v-divider/>

              <v-list-tile avatar class="vlist">
                <v-list-tile-avatar color="#35455c">
                  <v-img
                    :src="displayAvatar()"        
                  />
                </v-list-tile-avatar>
                <v-list-tile-title class="title font-weight-light mt-1 white--text">{{displayName()}}</v-list-tile-title>
              </v-list-tile>
              <v-divider />
              <v-list>
                <v-list-tile route to="/home/default" active-class="amber black--text" avatar>
                  <v-list-tile-action>
                    <v-icon>dashboard</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="font-weight-light">Dashboard</v-list-tile-title>
                </v-list-tile>
                <v-list-group
                  v-for="item in items"
                  :key="item.title"
                  v-model="item.active"
                  :prepend-icon="item.action"
                  active-class = "white--action"
                  no-action
                  
                >
                  <template v-slot:activator >
                    <v-list-tile class="vlist">
                      <v-list-tile-content>
                        <v-list-tile-title class="font-weight-light">{{ item.title }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <v-list-tile
                    v-for="subItem in item.items"
                    :key="subItem.title"
                    route
                    :to="subItem.to"
                    active-class="amber black--text"
                    class="vlist"
                    
                  >
                    
                    <v-list-tile-content>
                      <v-list-tile-title class="font-weight-light">{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action >
                      <v-icon >{{ subItem.action }}</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>
                <v-list-tile route to="/home/future" active-class="amber black--text" avatar class="vlist">
                  <v-list-tile-action>
                    <v-icon>timeline</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="font-weight-light">Future</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-layout>
          
        </v-flex>
      </v-card>
      </v-img>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import firebase from 'firebase'
export default {
  data() {
    return {
      drawer: true,
      user: {
        name: firebase.auth().currentUser.displayName,
        avatar: firebase.auth().currentUser.photoURL
      },
      items: [
        {
          action: "fas fa-car",
          title: "Conveyance",
          items: [
            {
              title: "Post",
              action: "fas fa-address-card",
              to: "/home/post"
            },
            {
              title: "Search",
              action: "fas fa-search",
              to: "/home/search"
            },
            {
              title: "MyRequest",
              action: "fas fa-share",
              to: "/home/myrequest"
            }
          ]
        },
        {
          action: "fas fa-store",
          title: "Buy And Sell",
          items: [
            { title: "Buy", action: "fas fa-shopping-cart", to: "/home/buy" },
            { title: "Sell", action: "fas fa-money-check-alt", to: "/home/sell" },
            { title: "My Bids", action: "fas fa-comments-dollar", to: "/home/mybids" },
          ]
        }
      ]
    };
  },
  
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    signout() {
      var vm=this;
      firebase.auth().signOut().then(function () {
        vm.$router.push('/login');
      }).catch(function (error) {
        window.alert(error.message);
      })
    },
    displayName(){
      return firebase.auth().currentUser.displayName;
    },

    displayAvatar(){
      return firebase.auth().currentUser.photoURL;
    }
  },
};
</script>

<style>
  .vlist{
    border-radius: 10px;
  }
</style>
